import { Wizard } from 'react-use-wizard'
import { Wrapper } from 'Surveys/shared/Styles'
import Step1 from './Steps/Step1'
import Step2 from './Steps/Step2'
import Step3 from './Steps/Step3'
import { useState } from 'react'

const NoAddendum = ({ close = () => {}, extendedStay = {} }) => {
    const [data, setData] = useState(null)
    return (
        <Wizard wrapper={<Wrapper />}>
            <Step1 data={data} setData={setData} es={extendedStay} />
            <Step2 data={data} setData={setData} es={extendedStay} />
            <Step3 data={data} setData={setData} es={extendedStay} close={close} />
        </Wizard>
    )
}

export default NoAddendum
